import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Fade, Divider } from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Info as InfoIcon,
  BarChart as BarChartIcon,
  History as HistoryIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';

export default function RunActions(props) {

  const { run_key, user_key } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDelete = () => {
    setAnchorEl(null);
    setOpenDialog(true);
  };

  return (
    <>
      <DeleteConfirmationDialog
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        run_key={run_key}
        user_key={user_key}
      />
      <Button
        id="run-action-button"
        aria-controls={open ? 'run-action-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="outlined"
        disableElevation
        endIcon={<KeyboardArrowDownIcon />}
      >
        Actions
      </Button>
      <Menu
        id="run-action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'run-action-button',
        }}
        TransitionComponent={Fade}
      >
        <MenuItem
          onClick={handleClose} 
          component={Link}
          to={{
            pathname: `/xaudiences/${run_key}`,
            search: user_key && `user_key=${user_key}`,
          }}
        >
          <ListItemIcon>
            <InfoIcon color={"primary"}/>
          </ListItemIcon>
          <ListItemText>
            Details
          </ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleClose} 
          component={Link}
          to={{
            pathname: `/xaudiences/${run_key}/history`,
            search: user_key && `user_key=${user_key}`,
          }}
        >
          <ListItemIcon>
            <HistoryIcon color={"primary"} />
          </ListItemIcon>
          <ListItemText>
            History
          </ListItemText>
          </MenuItem>
        <MenuItem
          onClick={handleClose} 
          component={Link}
          to={{
            pathname: `/xaudiences/${run_key}/analytics`,
            search: user_key && `user_key=${user_key}`,
          }}
        >
          <ListItemIcon>
            <BarChartIcon color={"primary"} />
          </ListItemIcon>
          <ListItemText>
            Analytics
          </ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleDelete}
        >
          <ListItemIcon>
            <DeleteIcon color={"error"} />
          </ListItemIcon>
          <ListItemText>
            Delete
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
